import React from 'react';
import PropTypes from 'prop-types';

function RadioGroup(props) {
  return props.listIds.map(function generateRadioButtons(listId, index) {
    return (
      <label key={listId} htmlFor={listId}>
        <input
          type="radio"
          name={props.listIds.toString()}
          value={listId}
          id={listId}
          checked={props.checked[index]}
          onChange={props.onChange}
        />
        <span className="newsletter__option">{props.choices[index]}</span>
      </label>
    );
  });
}

RadioGroup.propTypes = {
  listIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  checked: PropTypes.arrayOf(PropTypes.bool).isRequired,
  onChange: PropTypes.func.isRequired,
  choices: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default RadioGroup;
